/* eslint-disable valid-typeof */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/ReactToastify.css';
import { ThemeProvider } from 'styled-components';
import App from './App';
import { AddressContextProvider } from './hooks/context/useAddressContext';
import { CartContextProvider } from './hooks/context/useCartContext';
import { FiltersContextProvider } from './hooks/context/useFiltersContext';
import { GiftContextProvider } from './hooks/context/useGiftContext';
import { MenuContextProvider } from './hooks/context/useMenuContext';
import reportWebVitals from './reportWebVitals';
import { BASE_URL, GLOBAL_PREFIX } from './styles/constants';
import './styles/globals.scss';
import './styles/resets.scss';
import { theme } from './styles/theme';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

console.log('WINDOW CONFIG', window.config);

export const URL_SUFFIX = process.env.REACT_APP_GITHUB_COMMIT_SHORT
  ? '/?hash=' + process.env.REACT_APP_GITHUB_COMMIT_SHORT
  : '';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'always',
      queryFn: async ({ queryKey: [url, filter = {}] }) => {
        if (typeof url === 'string') {
          const jsonRpc = {
            jsonrpc: '2.0',
            ns: GLOBAL_PREFIX,
            method: `${url.toLowerCase()}`,
            params: filter,
            id: `${Date.now()}`,
          };
          const { data } = await axios.post(
            `${BASE_URL}/${url.toLowerCase()}`,
            jsonRpc,
            { headers: { 'x-winamax-public-endpoint-version': 2 } },
          );
          if (data.error)
            throw new Error(
              data.error.data.message?.join(' | ') ?? data.error.message,
            );
          return data.result;
        }
        throw new Error('Invalid QueryKey');
      },
    },
  },
});

console.log('BASE URL', BASE_URL);

let BASE_PATH = '';
if (typeof window !== undefined) BASE_PATH = window.config?.BASE_PATH;

root.render(
  <QueryClientProvider client={client}>
    <BrowserRouter basename={BASE_PATH}>
      <React.StrictMode>
        <MenuContextProvider>
          <CartContextProvider>
            <GiftContextProvider>
              <AddressContextProvider>
                <FiltersContextProvider>
                  <ThemeProvider theme={theme}>
                    <App />
                  </ThemeProvider>
                </FiltersContextProvider>
              </AddressContextProvider>
            </GiftContextProvider>
          </CartContextProvider>
        </MenuContextProvider>
      </React.StrictMode>
    </BrowserRouter>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
